
// ROUTES
require('modules/archive-event/routes/archive-event');
// require('modules/archive-event/routes/archive-event-directory');

// CONTROLLERS
require('modules/archive-event/controllers/archive-event');
require('modules/archive-event/controllers/list');
require('modules/archive-event/controllers/years');


// SERVICES
require('modules/archive-event/services/archive-event');
require('modules/archive-event/services/list');
require('modules/archive-event/services/edit');


angular.module('unica_archive_event', [

	// ROUTES
	'unica_archive_event.archive_event_routes',

	// CONTROLLERS
	'unica_archive_event.archive_event_controllers',

	// SERVICES
	'unica_archive_event.archive_event_services'

]);